import axios from 'axios'
import { hideLoading, showLoading } from './loading'
import { refreshJwtToken } from '@/api/base'
import { Message } from 'element-ui'
import { getAccessToken, getRefreshToken, removeToken, setToken } from '@/util/util.ruquest'
import router from '@/router'

// 创建一个错误
function errorCreate (msg) {
  Message.error(msg)
  throw new Error(msg)
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 120000 // 请求超时时间2min
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    showLoading()
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    // 发送失败
    console.log(error)
    return Promise.reject(error)
  }
)
// 响应拦截器
service.interceptors.response.use(
  response => {
    hideLoading()
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    // 这个状态码是和后端约定的
    const { code } = dataAxios
    // 根据 code 进行判断
    if (code === undefined) {
      return dataAxios
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      const number = parseInt(code)
      if (number === 200) {
        return dataAxios
      } else if (number === 401) {
        // 401 登录过期
        // errorCreate(`[ code: xxx ] ${dataAxios.messages}: ${response.config.url}`)
        if (process.env.NODE_ENV === 'development') {
          errorCreate(`${dataAxios.message}: ${response.config.url}`)
        } else {
          errorCreate(`${dataAxios.message}`)
        }
      } else {
        // 不是正确的 code
        if (process.env.NODE_ENV === 'development') {
          // errorCreate(`${dataAxios.messages}: ${response.config.url}`)
          errorCreate(`${dataAxios.message}`)
        } else {
          errorCreate(`${dataAxios.message}`)
        }
      }
    }
  },
  error => {
    hideLoading()
    if (error && error.response) {
      const responseCode = parseInt(error.response.data.code)
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          if (responseCode === 460) {
            return retryRequestAfterRefreshToken(error)
          } else if (responseCode === 480) {
            removeToken()
            router.push({
              name: 'login'
            })
          }
          error.message = '登录过期，请重新登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          if (process.env.NODE_ENV === 'development') {
            error.message = `请求地址出错: ${error.response.config.url}`
          } else {
            error.message = '请求地址出错'
          }
          break
        case 408:
          error.message = '请求超时'
          break
        case 417:
          error.message = `${error.response.data.messages}`
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)

// 刷新token
async function retryRequestAfterRefreshToken (data) {
  await new Promise((resolve) => {
    const refreshToken = getRefreshToken()
    if (!refreshToken || refreshToken === '') {
      throw new Error('未获取到刷新token')
    }
    refreshJwtToken(refreshToken)
      .then(async res => {
        res = res.data
        setToken(res.accessToken, res.refreshToken)
        resolve(res)
      })
      .catch(err => {
        console.log(err)
      })
  }).then(async res => {
    const config = data.response.config
    const baseURL = config.baseURL
    if (config.url.slice(0, baseURL.length) === baseURL) {
      config.url = config.url.slice(baseURL.length)
    }
    // 重新请求
    data = await service.request(config)
  })
  return data
}

export default service
